import type { Params, Return } from './useRemoteAsset.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * NOTE: Asset caching is only available on native platforms.
 *
 * Simply returns the original URL without caching.
 */
export const useRemoteAsset = (params: Params): Return => {
  const { url } = params;

  return {
    isDownloading: false,
    hasDownloaded: true,
    failedToDownload: false,
    localURI: url,
    error: undefined,
    retry: noop,
  };
};

// ─────────────────────────────────────────────────────────────────────────────

function noop() {}
